import api from './axios';

export const getStaff = async (params) => {
  const response = await api.get('/staff', { params });
  return response.data;
};

export const getStaffMember = async (id) => {
  const response = await api.get(`/staff/${id}`);
  return response.data;
};

export const createStaff = async (data) => {
  const response = await api.post('/staff', data);
  return response.data;
};

export const updateStaff = async (id, data) => {
  const response = await api.put(`/staff/${id}`, data);
  return response.data;
};

export const deleteStaff = async (id) => {
  const response = await api.delete(`/staff/${id}`);
  return response.data;
};

export const getByType = async (type) => {
  const response = await api.get(`/staff/type/${type}`);
  return response.data;
};

export const getActiveStaff = async () => {
  const response = await api.get('/staff/active/all');
  return response.data;
};

export const getTodayRoster = async () => {
  const response = await api.get('/staff/roster/today');
  return response.data;
};

export const getRosterByDate = async (date) => {
  const response = await api.get(`/staff/roster/date/${date}`);
  return response.data;
};

export const filterStaff = async (filters) => {
  const response = await api.post('/staff/filter', filters);
  return response.data;
};

export const getAttendance = async (date) => {
  const response = await api.get(`/staff/attendance/${date}`);
  return response.data;
};

export const saveAttendance = async (data) => {
  const response = await api.post('/staff/attendance', data);
  return response.data;
};

export const uploadStaffPhoto = async (file) => {
  const formData = new FormData();
  formData.append('photo', file);
  const response = await api.post('/uploads/staff-photo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadStaffAadhar = async (file) => {
  const formData = new FormData();
  formData.append('aadhar', file);
  const response = await api.post('/uploads/staff-aadhar', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
